<template>
  <div>
    <h1>Figma Tips</h1>
    <p>This page contains a series of mini silent videos to show how to do basic things in Figma quickly.</p>

    <h2>Renaming a composition</h2>
    <Video src="/screencaps/week5/renaming_composition.mp4" style="max-width: 700px" />
    <h2>Creating a frame</h2>
    <Video src="/screencaps/week5/making_frame.mp4" style="max-width: 700px" />
    <h2>Making a rectangle</h2>
    <Video src="/screencaps/week5/making_a_rectangle.mp4" style="max-width: 700px" />
    <h2>Adding corner radius</h2>
    <Video src="/screencaps/week5/adding_corner_radius.mp4" style="max-width: 700px" />
    <h2>Duplicating objects</h2>
    <Video src="/screencaps/week5/duplicating_objects.mp4" style="max-width: 700px" />
    <h2>Resizing objects</h2>
    <Video src="/screencaps/week5/resizing_object.mp4" style="max-width: 700px" />
    <h2>Changing fill color</h2>
    <Video src="/screencaps/week5/changing_fill_color.mp4" style="max-width: 700px" />
    <h2>Drawing a line</h2>
    <Video src="/screencaps/week5/drawing_a_line.mp4" style="max-width: 700px" />
    <h2>Dragging a line to snap</h2>
    <Video src="/screencaps/week5/dragging_a_line_to_snap.mp4" style="max-width: 700px" />
    <h2>Changing line color and thickness</h2>
    <Video src="/screencaps/week5/changing_line_color_and_thickness.mp4" style="max-width: 700px" />
    <h2>Resizing a line</h2>
    <Video src="/screencaps/week5/resizing_line.mp4" style="max-width: 700px" />
    <h2>Creating text</h2>
    <Video src="/screencaps/week5/creating_text.mp4" style="max-width: 700px" />
    <h2>Styling text</h2>
    <Video src="/screencaps/week5/styling_text.mp4" style="max-width: 700px" />
    <h2>Grouping objects</h2>
    <Video src="/screencaps/week5/grouping_objects.mp4" style="max-width: 700px" />
    <h2>Duplicating groups and editing groups</h2>
    <Video
      src="/screencaps/week5/duplicating_groups_and_editing_groups.mp4"
      style="max-width: 700px"
    />
    <h2>Ungrouping</h2>
    <Video src="/screencaps/week5/ungrouping.mp4" style="max-width: 700px" />
    <h2>Aligning</h2>
    <Video src="/screencaps/week5/aligning.mp4" style="max-width: 700px" />
    <h2>Adding finishing touches</h2>
    <Video src="/screencaps/week5/adding_finishing_touches.mp4" style="max-width: 700px" />
    <h2>Exporting compositions</h2>
    <Video src="/screencaps/week5/exporting.mp4" style="max-width: 700px" />
    <h2>Saving Google Chart as SVG</h2>
    <Video src="/screencaps/week5/saving_google_chart_as_svg.mp4" style="max-width: 700px" />
    <h2>Importing Google Chart into Figma</h2>
    <Video src="/screencaps/week5/importing_google_chart_into_figma.mp4" style="max-width: 700px" />
    <h2>Customizing Google Sheet</h2>
    <Video src="/screencaps/week5/customizing_google_sheet.mp4" style="max-width: 700px" />
    <h2>Creating circles and arcs</h2>
    <Video src="/screencaps/week5/circles_and_arcs.mp4" style="max-width: 700px" />
  </div>
</template>

<script>
import Video from "../../Video";

export default {
  components: { Video }
};
</script>